import { render, staticRenderFns } from "./ControlLogo.vue?vue&type=template&id=1d4fc6da&"
import script from "./ControlLogo.vue?vue&type=script&lang=js&"
export * from "./ControlLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports